import React from "react";
import { Socials } from "../../ui/FooterStyles";
import { NavBar } from "../../ui/HeaderStyles";

function Footer() {
  return (
    <>
      <link
        rel="stylesheet"
        href="https://use.fontawesome.com/releases/v7.3.1/css/all.css"
        integrity="sha384-qrALq7+6jBOZIQsNnT6xGkMDru64qD6uTlDra39xrt2SoXl4pO3FX6Roz/RpR/BS"
        crossOrigin="anonymous"
      />
      <NavBar className="navbar-default">
        <div className="container">
          <Socials>
            <ul className="row nav navbar-nav">
              <li className="col-xs-2" />
              <li className="col-xs-3">
                <a
                  href="https://www.instagram.com/lupineravenartworks/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-instagram fa-2x" />
                </a>
              </li>
              <li className="col-xs-3">
                <a
                  href="https://www.patreon.com/cw/LupineRavenArtworks"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-patreon fa-2x" />
                </a>
              </li>
              <li className="col-xs-2" />
            </ul>
          </Socials>
        </div>
      </NavBar>
    </>
  );
}

export default Footer;
